module.exports = __webpack_public_path__ + "media/images/pic06-f2d31930cd3dd9fb36c6c927c77ff1c5.jpg";